import { Icons } from '@/components/icons';
import {
  defaultEnumFilter,
  defaultNumberFilter,
  defaultRelationFilter,
  defaultSelectFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';
import { isFeatureEnabled } from '@/hooks/use-feature-flag';
import { FEATURE_FLAGS } from '@/hooks/use-feature-flag/constants';
import { ApartmentConfig, TenantConfig } from '@pigello/pigello-matrix';
import baseRevenueIncreaseFilters from '../contracts/components/base-revenue-increase-filters';
import baseFilters, {
  baseAddressFilters,
  baseBuildingFilter,
  baseGlobalRealEstatesFilter,
  baseSpaceFutureContractingFilters,
  baseSpaceStatusFilters,
  baseTagFilter,
} from '../filters';

const apartmentFilters: Filter[] = [
  ...baseSpaceStatusFilters,
  ...baseSpaceFutureContractingFilters,
  ...baseBuildingFilter,
  ...baseGlobalRealEstatesFilter,
  {
    ...defaultSelectFilter,
    title: ApartmentConfig.fields.category.verboseName,
    externalFieldName: ApartmentConfig.fields.category.externalFieldName,
    choices: ApartmentConfig.fields.category.choices,
  },
  {
    ...defaultStringFilter,
    title: ApartmentConfig.fields.apartmentId.verboseName,
    externalFieldName: ApartmentConfig.fields.apartmentId.externalFieldName,
    icon: Icons.id,
  },
  {
    ...defaultStringFilter,
    title: ApartmentConfig.fields.popularName.verboseName,
    externalFieldName: ApartmentConfig.fields.popularName.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: ApartmentConfig.fields.landlordCustomId.verboseName,
    externalFieldName:
      ApartmentConfig.fields.landlordCustomId.externalFieldName,
    icon: Icons.id,
  },
  {
    ...defaultNumberFilter,
    title: ApartmentConfig.fields.usableArea.verboseName,
    externalFieldName: ApartmentConfig.fields.usableArea.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: ApartmentConfig.fields.biArea.verboseName,
    externalFieldName: ApartmentConfig.fields.biArea.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: ApartmentConfig.fields.temperedArea.verboseName,
    externalFieldName: ApartmentConfig.fields.temperedArea.externalFieldName,
  },

  {
    ...defaultRelationFilter,
    title: ApartmentConfig.fields.tenant.verboseName,
    externalFieldName: ApartmentConfig.fields.tenant.externalFieldName,
    relationModelName: TenantConfig.modelName,
    icon: Icons.tenant,
  },
  {
    ...defaultRelationFilter,
    title: ApartmentConfig.fields.biTenants.verboseName,
    externalFieldName: ApartmentConfig.fields.biTenants.externalFieldName,
    relationModelName: TenantConfig.modelName,
    icon: Icons.tenant,
  },
  {
    ...defaultStringFilter,
    title: ApartmentConfig.fields.customId.verboseName,
    externalFieldName: ApartmentConfig.fields.customId.externalFieldName,
    icon: Icons.id,
  },
  ...(isFeatureEnabled(FEATURE_FLAGS.MARKET)
    ? [
        {
          ...defaultEnumFilter,
          title: 'Annonser',
          externalFieldName: 'custom_space_check_active_listing',
          enumChoices: [
            {
              title: 'Aktiv/kommande annons',
              badgeVariant: 'green' as const,
              filters: [
                { operator: 'noop' as const, value: 'has_active_listing' },
              ],
            },
            {
              title: 'Saknar aktiv/kommande annons',
              badgeVariant: 'destructive' as const,
              filters: [
                { operator: 'noop' as const, value: 'no_active_listing' },
              ],
            },
          ],
        },
      ]
    : []),
  ...baseRevenueIncreaseFilters,
  ...baseAddressFilters,
  ...baseTagFilter,
  ...baseFilters,
];

export default apartmentFilters;
